(function (angular) {
    'use strict';

    angular.module('app')
        .controller('memberController', memberController);

    memberController.$inject = [
        '_',
        '$rootScope',
        'memberPayload',
        'queryParams',
        'thisSiteSettings',
        'Users',
        'UsersApi',
        'ConnectsApi',
        'industries',
        'thisUser',
        '$sce',
    ];

    function memberController(
        _,
        $rootScope,
        memberPayload,
        queryParams,
        thisSiteSettings,
        Users,
        UsersApi,
        ConnectsApi,
        industries,
        thisUser,
        $sce,
    ) {
        var vm = this;
        let loadedMemberConnections = false;

        // properties
        vm.moment = window.moment;
        vm.member = new UsersApi(memberPayload);
        industries.unshift('-- All --');
        vm.industries = industries;
        // vm.filterOpen = false;

        // methods
        vm.sendMessage = sendMessage;
        vm.manageAccount = manageAccount;
        vm.renderCustomAttr = renderCustomAttr;
        vm.canShowAttr = canShowAttr;
        vm.getMemberConnections = getMemberConnections;
        vm.getDescription = getDescription;

        vm.distanceSliderOptions = {
            stepsArray: getDistanceSliderSteps(),
            showTicks: false,
            translate: function (step) {
                if (step === 20000) {
                    return 'Any Distance';
                }
                return step + ' miles';
            }
        };
        
        // Set filter defaults
        vm.memberFilters = {
            company: null,
            full_name: null,
            industry: null,
            near_distance: null,
            near: null,
            page_size: 100,
            user_id_from: vm.member.id,
            with: 'userTo',
        };

        setPageTitle();

        function setPageTitle() {
            document.title = document.title.replace('Member', vm.member.full_name);
        }
        
        // Call member connections function after filter defaults have been set
        getMemberConnections();

        /**
         * Builds an array of steps for the distance slider control
         * @return {array}
        */
        function getDistanceSliderSteps() {
            var steps = [],
                i = 1;

            for (i; i < 50; i++) {
                steps.push(i);
            }

            steps.push(20000);

            return steps;
        }

        // Open the manage user modal to add more info if the user has just logged in via oAuth
        if (queryParams.r) {
            manageAccount();
        }
        function manageAccount() {
            Users.edit(vm.member.id).result.then(function (user) {
                if (user) {
                    vm.member = new UsersApi(user);
                }
            });
        }
        /**
         * Opens modal to send a message to this user
         * @param  {int} userId - ID of user to send message to
         * @return {void}
         */
        function sendMessage(userId) {
            Users.sendMessage(userId);
        }

        /**
         * Render a custom attribute according to its type
         *
         * @param  {string}    key   The attribute key
         * @param  {string}    type  The attribute type
         * @return {string}
         */
        function renderCustomAttr(key, type) {
            switch (type) {
                case 'checkboxes':
                    var options = thisSiteSettings.user_attrs;
                    var option = options.find(function (item) {
                        return item.key == key;
                    });
                    var values = vm.member.custom_attrs[key].map(function (v, i) {
                        return v === 1 ? option.options.options[i].value : null;
                    }).filter(function (v) {
                        return v;
                    });

                    return values.join(', ');
                default:
                    return vm.member.custom_attrs[key];
            }
        }
        /**
        * Retrieves this member's connections from the API
        * @return {void}
        */
        function getMemberConnections() {
            vm.isLoadingConnections = true;

            const handleMemberConnectionsResponse = (response) => {
                vm.connections = response;
                loadedMemberConnections = true;
                vm.isLoadingConnections = false;
                // vm.filterOpen = false;
            };

            ConnectsApi.get(
                vm.memberFilters,
                handleMemberConnectionsResponse
            );
        }

        /**
         * Determines whether an attribute can be displayed
         *
         * @param {string} key
         * @returns {boolean}
         */
        function canShowAttr(key) {
            var attr = _.find(thisSiteSettings.user_attrs, { key: key }) || {};
            var canShow = (!!attr.visible && !attr.private) || (!!attr.visible && !!attr.private && !!$rootScope.thisUser);
            return canShow;
        }

        /**
         * Allows full html with styling to be shown - ngSanatize santaizes it
         * @param {string} description
         * @return {string}
         */
         function getDescription(description) {
            return $sce.trustAsHtml(description);
        }
    }

}(angular));
